import React, { Component } from 'react';
import SystemTranslationStatistic from './SystemTranslationStatistic';
import { browserHistory } from 'react-router';
import { observer } from 'mobx-react';
import SystemTranslationItemTypeInstructionStatisticService from '../services/SystemTranslationItemTypeInstructionStatisticService';

class SystemTranslationItemTypeInstructionStatisticContainer extends Component {
  systemTranslationItemTypeInstructionStatisticService = new SystemTranslationItemTypeInstructionStatisticService();

  componentDidMount() {
    this.systemTranslationItemTypeInstructionStatisticService.load();
  }

  render() {
    return (
      <SystemTranslationStatistic
        title="Item Types Instructions"
        icon="sound"
        value={this.systemTranslationItemTypeInstructionStatisticService.summary}
        fetching={this.systemTranslationItemTypeInstructionStatisticService.fetch.fetching}
        onClick={() =>
          browserHistory.push({
            pathname: '/item-types',
            state: { from: { text: 'System Translations', pathname: '/system-translations' } },
          })
        }
      />
    );
  }
}

export default observer(SystemTranslationItemTypeInstructionStatisticContainer);
